import Logo from "../../../img/logo.png"
export const Data=[
    {
        logo:Logo,
        home:"HOME",
        about:"ABOUT",
        services:"SERVICES",
        resume:"RESUME",
        work:"WORK",
        contact:"CONTACT"   
    }
]
